import { Loader2, Hammer } from "lucide-react";

export function Loader({ full = false, label = "Carregando..." }) {
  return (
    <div
      data-testid="loader"
      className={`flex flex-col items-center justify-center gap-3 text-muted-foreground ${full ? "min-h-[60vh]" : "py-16"}`}
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function EmptyState({ title = "Nenhum projeto encontrado.", subtitle, icon: Icon = Hammer, action }) {
  return (
    <div data-testid="empty-state" className="flex flex-col items-center justify-center gap-4 py-20 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <div>
        <p className="text-lg font-semibold">{title}</p>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground max-w-sm">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
